import * as user from './user.service';
import * as map from './map.service';
import * as auth from './auth.service';
import * as team from './team.service';
import * as enquiry from './enquiry.service';
import * as file from './file.service';
import * as organisation from './organisation.service';
import * as mailbox from './mailbox.service';
import * as appConfig from './app-config.service';

const Service = {
  user,
  map,
  auth,
  team,
  file,
  enquiry,
  organisation,
  mailbox,
  appConfig
};

export {
  user,
  map,
  auth,
  team,
  file,
  enquiry,
  organisation,
  mailbox,
  appConfig
};

export default Service;
